import { UntypedFormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { PlanogramModal, SKUModal } from 'src/modals/planogram';
import { CONFIG } from './app-config';

export function noWhitespaceValidator(control: UntypedFormControl) {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
}

export function getPlanogramImageUrl(
  id: number,
  // name: string,
  user_name:string,
  cooler:string,
  is_time_span: boolean = true
) {
  if (is_time_span) {
    return `https://${environment.picturesAccount}.blob.core.windows.net/${environment.picturesContainer}/PlanogramImages/${id}_${user_name}_${cooler}_cooler_image`;
    //return   `https://${environment.picturesAccount}.blob.core.windows.net/${environment.picturesContainer}/PlanogramImages/planogram_test_01.png?${environment.sas}`;
  } else {
    return `https://${environment.picturesAccount}.blob.core.windows.net/${environment.picturesContainer}/PlanogramImages/${id}_${user_name}_${cooler}_cooler_image`;
    //return `https://${environment.picturesAccount}.blob.core.windows.net/${environment.picturesContainer}/PlanogramImages/planogram_test_01.png?${environment.sas}`;
  }
}

export function abbreviateNumber(
  num: number,
  fixed: number = CONFIG.DECIMALPLACE,
  number_format: string = 'default'
) {
  if (num === null || num === undefined) {
    return null;
  } // terminate early
  if (isNaN(num) || num === 0) {
    return '0';
  } // terminate early
  fixed = !fixed || fixed < 0 ? 0 : fixed; // number of decimal places to show
  let b = num.toPrecision(2).split('e'), // get power
    k =
      b.length === 1 ? 0 : Math.floor(Math.min(Number(b[1].slice(1)), 14) / 3); // floor at decimals, ceiling at trillions
  k =
    number_format != 'default'
      ? CONFIG.NUMBER_SUFFIX.findIndex((s) => s === number_format)
      : k;
  let c =
      k < 1
        ? num.toFixed(0 + fixed)
        : (num / Math.pow(10, k * 3)).toFixed(fixed), // divide by power
    d = Number(c) < 0 ? c : Math.abs(Number(c)), // enforce -0 is 0
    abbr = Number(d).toFixed(fixed) + CONFIG.NUMBER_SUFFIX[k];
  return abbr;
}

export function sortSkusAccordingToBrandOrderAndSize(sku_list: SKUModal[]) {
  sku_list.sort((sk1, sk2) => {
    if (sk1.brand_order && sk2.brand_order) {
      if (sk1.brand_order < sk2.brand_order) {
        return -1;
      } else if (sk1.brand_order > sk2.brand_order) {
        return 1;
      } else {
        return sk1.sku_volume - sk2.sku_volume;
      }
    } else {
      return 0;
    }
  });
  return sku_list;
}

export function getPlacedSkuDetail(planogram_placed_skus: SKUModal[]) {
  let skus: any = {};
  planogram_placed_skus.forEach((sk) => {
    if (skus[sk.sku_id]) {
      skus[sk.sku_id] += 1;
    } else {
      skus[sk.sku_id] = 1;
    }
  });
  return skus;
}

export function shelfHeight(row_index: number, cooler_config: PlanogramModal) {
  let height_ = 0;
  if (
    cooler_config.ic_shelves &&
    !cooler_config.ic_shelves.includes(row_index)
  ) {
    height_ = cooler_config.max_sku_height_fc + CONFIG.SHELF_HEIGHT_CLEARANCE;
  } else {
    height_ = cooler_config.max_sku_height_ic + CONFIG.SHELF_HEIGHT_CLEARANCE;
  }
  return height_;
}

export function getChartColor(categories: string[], config: any) {
  let color: string[] = [];
  const updatedConfig: { [key: string]: string } = Object.fromEntries(
    Object.entries(config).map(([key, value]) => [
      key.toLowerCase().replace(/ /g, ''),
      typeof value === 'string' ? value : '',
    ])
  );
  categories.forEach((category) => {
    category = category.toLowerCase().replace(/ /g, '');
    if (updatedConfig[category]) {
      color.push(updatedConfig[category]);
    } else {
      color.push(CONFIG.BLACK_HEX_CODE);
    }
  });
  return color;
}

export function getFilledWidth(skus_placed_on_row: SKUModal[]) {
  let filled_width = 0;
  skus_placed_on_row.forEach((sk) => {
    filled_width += sk.sku_diameter_length;
  });
  return filled_width;
}
